import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.calculateRecommendation.success: {
            return action.payload;
        }

        case constants.calculateRecommendation.try:
        case constants.calculateRecommendation.error: {
            return initialState;
        }

        default:
            return state;
    }
}
